import Player from '../models/player';

class Stores {
    data;
    constructor() {
        this.data = Player;
    }

}
export default new Stores();